import gsap from 'gsap'

import { getTimelineParallaxOptions } from './shared'
import { Animation } from '@/types'

export const fullscreenCardAnimation = ({
  node,
  context,
  conditions
}: Animation) => {
  if (conditions?.isSmall) return

  const selector = context?.selector || gsap.utils.selector(node)

  /**
   * references
   */
  const card = selector('[data-motion-card]')

  /**
   * parallax animation
   */
  // const parallax = gsap
  //   .timeline({ ...getTimelineParallaxOptions(node) })
  //   .fromTo(card, { xPercent: 60 }, { xPercent: -60 })

  /**
   * revert
   */
  return () => {
    // parallax?.kill()
  }
}
